import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useDataSaver } from "@/context/DataSaverContext";
import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";

const SEEN = "data_saver_suggested";

// Once per session on a slow/metered connection (no manual choice yet): tell the pilgrim the mode switched on automatically.
export const DataSaverSuggest = () => {
  const { slow, pref, setSaver } = useDataSaver();
  const { tc } = useLang();
  const latest = useRef({ tc, setSaver });
  latest.current = { tc, setSaver };

  useEffect(() => {
    if (!slow || pref || sessionStorage.getItem(SEEN)) return;
    sessionStorage.setItem(SEEN, "1");
    setTimeout(() => {
      const { tc: t, setSaver: set } = latest.current;
      toast(t(UI.dataSaverSuggest), {
        id: "data-saver-auto",
        duration: 12000,
        action: { label: t(UI.dataSaverOk), onClick: () => {} },
        cancel: { label: t(UI.dataSaverDisable), onClick: () => set(false) },
      });
    }, 1200);
  }, [slow, pref]);
  return null;
};
